import {
  isReloadingForCurrentBuild,
  isStaleBuildError,
  reloadForCurrentBuild,
} from "src/lib/StaleBuild";

// The API client loads when a report is sent: error pages are part of every page's shell.
const loadPostErrorReport = async () => (await import("src/CalmLensApi")).postErrorReport;

export type ReportableError = Error & { digest?: string };

const reportedErrors = new WeakSet<object>();

// Query strings and fragments can hold invite tokens or sign-in codes, so only the path is sent.
const describeError = (error?: ReportableError) => ({
  url: `${window.location.origin}${window.location.pathname}`,
  message: error?.message ? error.message.slice(0, 1000) : undefined,
  digest: error?.digest,
});

/** Tells operators that an error screen was shown. Sends once per error and never throws. */
export const reportErrorShown = (error: ReportableError) => {
  // Code from a build that has since been replaced reloads the page onto the current one (once per
  // page, src/lib/StaleBuild.ts), and errors while it reloads are moot. A failed chunk preload on
  // hover isn't an error screen and doesn't get here: only a navigation that needs the code does.
  if (reportedErrors.has(error) || isReloadingForCurrentBuild()) return;
  if (isStaleBuildError(error) && reloadForCurrentBuild()) return;
  reportedErrors.add(error);
  const body = describeError(error);
  loadPostErrorReport()
    .then((postErrorReport) => postErrorReport.submit({ body }))
    .catch((reportError) => {
      console.warn("Failed to report error", reportError);
    });
};
